import { decrypt } from "./utils";
import { decryptPayload } from "../AcuvisorCustomerApp/utils/encryptDecrypt";

// Note: When moving customer app to different project, we need to call only decryptPayload here
const clearOutdatedLocalStorage = () => {
  const now = Date.now(); // Current timestamp
  const fortyEightHoursAgo = now - 48 * 60 * 60 * 1000; // 48 hours in milliseconds

  for (let i = 0; i < localStorage.length; i++) {
    try {
      const key = localStorage.key(i);
      const item = localStorage.getItem(key);
      if (!item) continue;

      let parsedItem;

      // Try to decrypt with both functions decrypt (B2B) and decryptPayload (B2C)
      try {
        parsedItem = JSON.parse(decrypt(item));
      } catch (e) {
        try {
          parsedItem = JSON.parse(decryptPayload(item));
        } catch (e) {
          // If both decryptions fail, continue to the next item
          continue;
        }
      }

      if (
        parsedItem &&
        parsedItem.timestamp &&
        parsedItem.timestamp < fortyEightHoursAgo
      ) {
        localStorage.removeItem(key);
      }
    } catch (e) {
      // console.log("Failed to clear local storage data: " + e.message);
      continue;
    }
  }
};

export default clearOutdatedLocalStorage;
